import fetchWebApi from 'api/fetchWebApi';

const postOneTimeToken = (): Promise<{ oneTimeToken: string }> =>
  fetchWebApi('/client/security/one-time-token', undefined, {
    method: 'post',
  });

export default postOneTimeToken;
